import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import Modal from 'react-modal';
import './modal.css';

const axiosInstance = axios.create({
  baseURL: 'https://v1-csapi.compsoft.com.br:823/pdv_exception',
  auth: { username: 'Portal', password: 'Portal1163' },
});

function formatarData(dataInput) {
  return new Date(dataInput).toLocaleString('pt-BR', { timeZone: 'UTC' });
}

function capitalizeFirstLetter(str) {
  return str.toLowerCase().replace(/(^|\s)\S/g, (match) => match.toUpperCase());
}

function classificarMensagem(mensagem) {
  const texto = mensagem || '';
  if (
    texto.includes('Unable to complete network request to host') ||
    texto.includes('Alerta-Sem')
  ) {
    return { tipo: 'Alerta', nivel: 'Moderado', alertClass: 'alert-warning', badgeClass: 'bg-warning text-dark', ordem: 2 };
  }
  if (
    texto.includes('Saindo da Contingencia Offline') ||
    texto.includes('Atualizacao concluida') ||
    texto.includes('Data de Validade do Certificado ja expirou') ||
    texto.includes('Cupom nao recuperado - Apos falha catastrofica') ||
    texto.includes('Cupom recuperado') ||
    texto.includes('Ativado modo Contingencia') ||
    texto.includes('Entrando em contingencia') ||
    texto.includes('Entrando em Contingencia Offline')
  ) {
    return { tipo: 'Aviso', nivel: 'Normal', alertClass: 'alert-success', badgeClass: 'bg-success', ordem: 3 };
  }
  return { tipo: 'Exceção', nivel: 'Grave', alertClass: 'alert-danger', badgeClass: 'bg-danger', ordem: 1 };
}

const ListaRegistros = () => {
  const [state, setState] = useState({
    registrosOriginais: [],
    registros: [],
    erro: false,
    modalIsOpen: false,
    modalData: [],
    ordenacao: 'desc',
    ordenacaoCampo: 'recepcao',
    filtroProjeto: ' Todos',
    projetos: [],
    dataAtualPorExtenso: '',
    ultimosDiasData: null,
  });

  const carregarDadosIniciais = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/false');
      const registrosOriginais = response.data.filter((r) => r.cnpj !== '11111111111111');
      const projetosUnicos = Array.from(new Set(registrosOriginais.map((registro) => registro.projeto)))
        .filter((projeto) => projeto !== 'Branco' && projeto !== 'Extra');
      setState((prevState) => ({
        ...prevState,
        registrosOriginais,
        projetos: [' Todos', ...projetosUnicos].sort(),
      }));
    } catch (error) {
      console.error('Erro ao carregar dados iniciais:', error);
      setState((prevState) => ({ ...prevState, erro: true }));
    }
  }, []);

  const filtrarPorProjeto = useCallback((projeto) => {
    setState((prevState) => ({
      ...prevState,
      registros: projeto === ' Todos' ? prevState.registrosOriginais : prevState.registrosOriginais.filter((registro) => registro.projeto === projeto),
      filtroProjeto: projeto,
    }));
  }, []);

  const excluirRegistroDoModal = useCallback(async (id) => {
    try {
      await axiosInstance.post(`/${id}`, '');
      setState((prevState) => ({
        ...prevState,
        modalData: prevState.modalData.filter((registro) => registro.controle !== id),
      }));
    } catch (error) {
      console.error('Erro ao excluir o registro:', error);
    }
  }, []);

  const closeModal = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      modalIsOpen: false,
    }));
    carregarDadosIniciais();
  }, [carregarDadosIniciais]);

  const excluirTodos = useCallback(async () => {
    try {
      const { modalData } = state;
      for (const registro of modalData) {
        await excluirRegistroDoModal(registro.controle);
      }
      closeModal();
    } catch (error) {
      console.error('Erro ao excluir todos os registros:', error);
    }
  }, [state, excluirRegistroDoModal, closeModal]);

  const exibirDetalhes = useCallback((recordsDoCnpj) => {
    setState((prevState) => ({
      ...prevState,
      modalData: recordsDoCnpj,
      modalIsOpen: true,
    }));
  }, []);

  const groupByCnpj = useCallback((records, ordenacaoCampo, ordem) => {
    const groupedData = records.reduce((acc, record) => {
      const { cnpj } = record;
      acc[cnpj] = (acc[cnpj] || []).concat(record);
      return acc;
    }, {});

    return Object.entries(groupedData)
      .map(([cnpj, records]) => {
        const classificacoes = records.map((r) => classificarMensagem(r.mensagem));
        const classificacao = classificacoes.reduce((mais, atual) =>
          atual.ordem < mais.ordem ? atual : mais
        );
        return { cnpj, records, count: records.length, classificacao };
      })
      .sort((a, b) => {
        if (a.classificacao.ordem !== b.classificacao.ordem) {
          return a.classificacao.ordem - b.classificacao.ordem;
        }
        if (ordenacaoCampo === 'recepcao') {
          return ordem === 'asc'
            ? new Date(a.records[0].recepcao) - new Date(b.records[0].recepcao)
            : new Date(b.records[0].recepcao) - new Date(a.records[0].recepcao);
        }
        return ordem === 'asc' ? a.count - b.count : b.count - a.count;
      });
  }, []);

  const fetchUltimosDias = useCallback(async (cnpj) => {
    try {
      const response = await axiosInstance.get(`https://v1-csapi.compsoft.com.br:823/exception/${cnpj}`);
      setState((prevState) => ({
        ...prevState,
        ultimosDiasData: response.data,
      }));
    } catch (error) {
      console.error('Erro ao buscar dados dos últimos dias:', error);
    }
  }, []);

  useEffect(() => {
    carregarDadosIniciais();
    const interval = setInterval(carregarDadosIniciais, 30000);

    const dataAtual = new Date();
    const dataFormatada = format(dataAtual, "EEEE, d 'de' MMMM 'de' yyyy", { locale: ptBR });
    setState((prevState) => ({
      ...prevState,
      dataAtualPorExtenso: dataFormatada,
    }));

    return () => clearInterval(interval);
  }, [carregarDadosIniciais]);

  useEffect(() => {
    filtrarPorProjeto(state.filtroProjeto);
  }, [state.registrosOriginais, state.filtroProjeto, filtrarPorProjeto]);

  const sortedRegistros = groupByCnpj(state.registros, state.ordenacaoCampo, state.ordenacao);

  return (
    <div>
      {state.erro ? (
        <div className="alert alert-danger">Erro ao carregar dados do servidor. Por favor, tente novamente mais tarde.</div>
      ) : (
        <React.Fragment>
          <h5 className="mb-3">{state.dataAtualPorExtenso}</h5>
          <div className="btn-group btn-group-sm mb-3" role="group" aria-label="Filtro de Projetos">
            {state.projetos.map((projeto, index) => (
              <button
                key={index}
                type="button"
                className={`btn ${state.filtroProjeto === projeto ? 'btn-success' : 'btn-outline-primary'}`}
                onClick={() => filtrarPorProjeto(projeto)}
              >
                {capitalizeFirstLetter(projeto)}
                <span className='badge bg-light text-dark ms-2'>
                  {projeto === ' Todos'
                    ? state.registrosOriginais.length
                    : state.registrosOriginais.filter((registro) => registro.projeto === projeto).length}
                </span>
              </button>
            ))}
          </div>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
            {sortedRegistros.length > 0 ? (
              sortedRegistros.map(({ cnpj, records, count, classificacao }) => (
                <div className="col" key={cnpj}>
                  <div className="card h-100 shadow-sm">
                    <div className="card-body d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h5 className="card-title mb-0">{records[0].nome}</h5>
                        <span className={`badge ${classificacao.badgeClass} rounded-pill fs-6`}>{count}</span>
                      </div>
                      <h6 className="card-subtitle mb-2 text-muted">{cnpj}</h6>
                      <p className="card-text text-sm mb-2">
                        <small className="text-muted">{records[0].classe} - {records[0].projeto}</small>
                      </p>
                      <div className={`alert ${classificacao.alertClass} p-2 mb-3`} role="alert">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <strong>Mensagem:</strong>
                          <span className={`badge ${classificacao.badgeClass} ms-2`}>
                            {classificacao.tipo} — {classificacao.nivel}
                          </span>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: records[0].mensagem }} />
                      </div>
                      <div className="mt-auto d-flex justify-content-end gap-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => exibirDetalhes(records)}>
                          Detalhes
                        </button>
                        <button className="btn btn-sm btn-outline-success" onClick={() => fetchUltimosDias(cnpj)}>
                          Últimos
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col">
                <div className="alert alert-info" role="alert">
                  Nenhum registro encontrado para o filtro selecionado.
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
      <Modal
        isOpen={state.modalIsOpen}
        onRequestClose={closeModal}
        contentLabel='Detalhes'
        className='react-modal-content'
        overlayClassName='react-modal-overlay'
      >
        <div className='modal-header modal-header-wrapper'>
          <h5 className="modal-title">Detalhes dos Registros</h5>
          <button type="button" className="btn-close" aria-label="Fechar" onClick={closeModal}></button>
        </div>
        {state.modalData.length > 0 ? (
          <div className='modal-table'>
            <table className='table table-hover font-sm data-table'>
              <thead className='table-header'>
                <tr>
                  <th>Classe/ID</th>
                  <th>Erro</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {state.modalData.map((registro, index) => (
                  <tr key={index}>
                    <td className='limited-cell'>
                      <p className="fw-bold mb-0">{registro.classe}</p>
                      <small className='text-muted text-nowrap'>{formatarData(registro.recepcao)}</small>
                    </td>
                    <td style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: registro.mensagem }} />
                    <td>
                    {localStorage.getItem('user-role') === 'MASTER' && (
                      <button className='btn btn-danger btn-sm' onClick={() => excluirRegistroDoModal(registro.controle)}>
                        Excluir
                      </button>
                    )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Nenhum registro encontrado.</p>
        )}
        {localStorage.getItem('user-role') === 'MASTER' && state.modalData.length > 0 && (
          <div className="modal-footer justify-content-end">
            <button className='btn btn-danger' onClick={excluirTodos}>
              Excluir Todos
            </button>
          </div>
        )}
      </Modal>
      <Modal
        isOpen={!!state.ultimosDiasData}
        onRequestClose={() => setState((prevState) => ({ ...prevState, ultimosDiasData: null }))}
        contentLabel='Últimos...'
        className='react-modal-content'
        overlayClassName='react-modal-overlay'
      >
        <div className='modal-header modal-header-wrapper'>
          <h5 className="modal-title">Últimos Registros</h5>
          <button type="button" className="btn-close" aria-label="Fechar" onClick={() => setState((prevState) => ({ ...prevState, ultimosDiasData: null }))}></button>
        </div>
        {state.ultimosDiasData ? (
          <div className='modal-table'>
            <table className='table table-hover font-sm data-table'>
              <thead className='table-header'>
                <tr>
                  <th>Classe/ID</th>
                  <th>Mensagem</th>
                  <th>Lido</th>                  
                </tr>
              </thead>
              <tbody>
                {state.ultimosDiasData.map((registro, index) => (
                  <tr key={index}>
                    <td className='limited-cell'>
                      <p className="fw-bold mb-0">{registro.classe}</p>
                      <small className='text-muted text-nowrap'>{formatarData(registro.recepcao)}</small>
                    </td>
                    
                    <td style={{ width: '75%' }} dangerouslySetInnerHTML={{ __html: registro.mensagem }} />
                    <td>
                      {registro.lido === 'S' && (<span className="text-success">&#10003;</span> )}
                    </td>                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Nenhum dado encontrado.</p>
        )}
      </Modal>
    </div>
  );
};

export default ListaRegistros;
